import BoxWithLabel from "../../box/BoxWithLabel";

import { useTranslation } from "react-i18next";

import IconButtonWithTooltip from "../../button/IconButtonWithTooltip";
import SchemaIcon from "@mui/icons-material/Schema";

import useDialog from "../../../hooks/useDialog";
import EquipmentSchemeListDialog from "../../dialog/EquipmentSchemeListDialog";

import useCheckPermission from "../../../hooks/usePermission";
import { EDIT_COUNTER_SCHEME_PERMISSION } from "../../../helpers/constants";

const MeterSchemeForm = (props) => {
  const { t } = useTranslation();

  const [hasPermissionToEditScheme] = useCheckPermission(
    EDIT_COUNTER_SCHEME_PERMISSION
  );

  const [
    openEquipmentSchemeDialog,
    onOpenEquipmentSchemeDialog,
    onCloseEquipmentSchemeDialog,
  ] = useDialog();

  return (
    <BoxWithLabel
      label={t("form.meter_passport.schemes")}
      boxStyle={{ height: "100%" }}
      style={{ height: "100%", display: "flex", justifyContent: "center" }}
    >
      <IconButtonWithTooltip
        title={t("form.meter_passport.scheme")}
        fontSize={"500%"}
        onClick={onOpenEquipmentSchemeDialog}
      >
        <SchemaIcon fontSize="inherit" color="primary" />
      </IconButtonWithTooltip>
      {openEquipmentSchemeDialog && (
        <EquipmentSchemeListDialog
          equipmentId={props.equipmentId}
          onClose={onCloseEquipmentSchemeDialog}
          open={openEquipmentSchemeDialog}
          isForElectricalEnergy={props.isForElectricalEnergy}
          readOnly={!hasPermissionToEditScheme}
        />
      )}
    </BoxWithLabel>
  );
};

export default MeterSchemeForm;
